import React from "react";
import { Create, useForm } from "@refinedev/antd";
import { Form, Input, InputNumber, Switch } from "antd";

export const TaxesCreate: React.FC = () => {
    const { form, formProps, saveButtonProps } = useForm({
        meta: {
            fields: ["taxTypeId", "taxType", "rate", "isActive"]
        }
    });

    return <Create saveButtonProps={saveButtonProps}>
        <Form form={form} {...formProps} layout="vertical">
            <Form.Item label="Tax Type" name="taxType" rules={[{ required: true }]}>
                <Input id="taxType" placeholder="e.g. VAT" />
            </Form.Item>
            <Form.Item label="Tax ID" name="taxTypeId" rules={[{ required: true }]}>
                <Input id="taxTypeId" placeholder="e.g. 1" />
            </Form.Item>
            <Form.Item label="Tax Rate as Percentage" name="rate" rules={[{ required: true }]}>
                <InputNumber min={0} max={100} id="rate" placeholder="e.g. 10" />
            </Form.Item>
            <Form.Item label="Is Active" name="isActive" valuePropName="checked" initialValue={true}>
                <Switch />
            </Form.Item>
        </Form>

    </Create >;
};
